<div class="flex flex-col lg:flex-row mg-background print:bg-contrast">
  <div class="flex-1 min-h-screen flex flex-col">
    <div class="flex-1 pb-2xl">
      <div class="print:hidden">
        <div class="border-b border-gray-200">
          <div
            class="w-full py-base lg:py-lg mx-auto header-container px-lg flex items-center justify-center lg:block border-b border-gray-200 lg:border-b-0"
            style="z-index: 1000"
          >
            <div class="flex items-center">
              <img
                class="lg:mr-[72px] cursor-pointer"
                src="assets/images/icons/big-logo-with-title-2.svg"
                [routerLink]="applicationRoutes.dashboard"
                width="142"
                alt="Logo"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="content-container mx-auto px-lg">
        <router-outlet></router-outlet>
      </div>
    </div>

    <div class="content-container w-full mx-auto px-lg pb-2xl print:hidden">
      <div class="border-t pt-lg border-gray-200 text-base leading-base text-txt-secondary">
        Copyright © 2024 by Market Genie v.1.0.3. All rights reserved.
      </div>
    </div>
  </div>
</div>
